import { Wishlist } from '@ynap/api-utils';
import { views } from '../constants';
const { ALERTS, INVENTORY, PRIVATE, BASE, PUBLIC, ALL_ITEMS } = views;

export default (view) => {
    switch (view) {
        case PRIVATE:
        case PUBLIC:
            return Wishlist.getWishlist;
        case BASE:
            return Wishlist.getAllWishlists;
        case ALL_ITEMS:
            return Wishlist.getAllWishlistItems;
        case ALERTS:
            return Wishlist.getAlerts;
        case INVENTORY:
            return Wishlist.getInventoryList;
        default:
            return Wishlist.getAllWishlists;
    }
};
